(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bv-cart-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bv-cart-estimate')) {
    class BvCartEstimate extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-destination]');
        let destination = 'mainland';
        try { destination = sessionStorage.getItem('bv-cart-destination') || destination; } catch (e) { /* Optional preference. */ }
        if (!['mainland', 'balearics', 'other'].includes(destination)) destination = 'mainland';
        if (this.select) this.select.value = destination;
        this.onChange = () => {
          try { sessionStorage.setItem('bv-cart-destination', this.select.value); } catch (e) { /* Optional preference. */ }
          document.querySelectorAll('bv-cart-estimate').forEach((element) => {
            if (element.select) element.select.value = this.select.value;
            element.update();
          });
        };
        if (this.select) this.select.addEventListener('change', this.onChange);
        this.update();
      }
      disconnectedCallback() {
        if (this.select) this.select.removeEventListener('change', this.onChange);
      }
      update() {
        const destination = this.select ? this.select.value : 'mainland';
        const unavailable = destination === 'other';
        this.querySelector('[data-quote]').hidden = unavailable;
        this.querySelector('[data-unavailable]').hidden = !unavailable;
        const firstQuote = this.querySelector('[data-first-quote]');
        if (firstQuote) firstQuote.hidden = unavailable;
        if (unavailable) return;
        const subtotal = Number(this.dataset.subtotal);
        const firstSubtotal = Number(this.dataset.firstSubtotal);
        const shipping = (amount) => this.dataset.shipping !== 'true' || amount >= 3999 ? 0 : destination === 'balearics' ? 577 : 438;
        const money = (cents) => new Intl.NumberFormat(this.dataset.locale || 'es', {style:'currency', currency:'EUR'}).format(cents / 100);
        const shippingPrice = this.querySelector('[data-shipping-price]');
        if (shippingPrice) shippingPrice.textContent = money(shipping(subtotal));
        this.querySelector('[data-total]').textContent = money(subtotal + shipping(subtotal));
        const firstTotal = this.querySelector('[data-first-total]');
        if (firstTotal) firstTotal.textContent = money(firstSubtotal + shipping(firstSubtotal));
      }
    }
    customElements.define('bv-cart-estimate', BvCartEstimate);
  }
  } catch(e) { console.error(e); }
})();

})();
